import { render, staticRenderFns } from "./NewBusinessDetail.vue?vue&type=template&id=5d4c925b&scoped=true&"
import script from "./NewBusinessDetail.vue?vue&type=script&lang=js&"
export * from "./NewBusinessDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewBusinessDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NewBusinessDetail.vue?vue&type=style&index=1&id=5d4c925b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c925b",
  null
  
)

export default component.exports